import { render, staticRenderFns } from "./PrintBarcode.vue?vue&type=template&id=924c9754&"
import script from "./PrintBarcode.vue?vue&type=script&lang=js&"
export * from "./PrintBarcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports